import React from 'react'

const IconClose = () => (
  <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="1.0-Dashboard" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Broker-Dashboard---mobile-nav" transform="translate(-23.000000, -23.000000)" fill="#FFFFFF">
        <g id="menu">
          <path
            d="M31,21 C31.5522847,21 32,21.4477153 32,22 L32,30 L40,30 C40.5522847,30 41,30.4477153 41,31 C41,31.5522847 40.5522847,32 40,32 L32,32 L32,40 C32,40.5522847 31.5522847,41 31,41 C30.4477153,41 30,40.5522847 30,40 L30,31.999 L22,32 C21.4477153,32 21,31.5522847 21,31 C21,30.4477153 21.4477153,30 22,30 L30,29.999 L30,22 C30,21.4477153 30.4477153,21 31,21 Z"
            id="icon-close" transform="translate(31.000000, 31.000000) rotate(-315.000000) translate(-31.000000, -31.000000) "/>
        </g>
      </g>
    </g>
  </svg>
)

export default IconClose
